var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorManagementSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1314_35300",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1314_35300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -3,
    width: 37,
    height: 31,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1314_35300",
    transform: "scale(0.0178571)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1314_35300",
    width: 56,
    height: 56,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAAXNSR0IArs4c6QAAA+5JREFUaIHtmVuIHEUUhr9/NWZdjLsqeHkwWTWCF4wIcQUJIogKLphXxQheCCIiKnhHWRVEH3zyRQn4JD4J6oNRUbygQiQBAysGYhKziWCiYrKruFlJ3N+H7k1qOt073V09oxnmg4GpOlV1zj9VPXWqGvr06dOng2gxo+1lwDgw2J1wKjMNfCxptqhBoUDbVwLvAaMdCKxJpoC1kibzjLkCbZ8KbOP/L26BKWCVpD+zhoGCDjdz4oiDJNaxPMPJBR1GMuXngS1NRtQAVwMTQfnsvEZFArNslvRBdEgNYrtUu6Il2jP0vMCyS7QRbO8Bhmt2n5G0omqnrgokEVdXYC26LXAvETNYp1OjAm2fAZwL7Jd0MGuXtKpJf2Vo5E/G9g22J4EDJBnQAdu7ba9rYvwYomfQ9rPACzmmUeBN2yslPZfpswS4saKreUkfVY0vSqDta8kXFzJhe1LSO0HdecDGiu5mOD7DakvsEn0xU/6eJK3bnql/JNJPbWrPoG3RmuDuAtZImrb9MrAVuCS1jdkeCs5tM8D9FV3+XSfOmCU6lH4W2C1pGkDSnO0fOCbwFJLlNZvaZ4DXI3yXpvYSlfQX8FtQtdr2CgDb5wPhljAH7K/rK4bYZ/Cr4PsIsMP2FpJnMTxPbpI0H+mrFrECnyC5F1lgCbAaWBbUGVgf6ac2UQIl7QTWAX8UNDkE3CdpV5nxbI/YftL2AzFxlXF0l1u5pU37Udtv2N5p+7DtfbZftX1pSX8jtp+y/Uvqb8b2onue7fFMjLfntWskF5U0BdxbtZ/tIeAxki3jnMB0OsneOZHXrwrdPk0AR4U9BDxOcXZyRRO+un3gvRi4E3iQYmGfAc9I2tSEz9hcdM0i5gGSm67lwDXATRSLMvAF8Kikb2NiyhKTqg3Tug/W5XPgaUnfNDDWcZQVOG574d7x3TTViuEI8CHwiqQvFyrTFbGy5BiXZ8r/lPZue62LWZ62GV6kTR4Hbb9t+2HbZxX4fa3imCHX541ZNIOfkJzMLyv9qySnhw1B+W5aTxtXpdtJJ/gR+DrPkCtQ0qztceBT4MKSTn6WdPSEYPs6WgV2KhedBG6VdCTPWPgMpr/2RbbHgDOBk1LTvsZDPMYG4P0K7fcA2yUdLmrQ9k9G0uYKDqOQtJVkqTdGz1/d97zAoje8t1HuSiG8pZ4Hwjesg8DSoBy7d7bjnszNHVD8DA5S/Yp9oE2fTr+TWJpX2fNLtGgGp4HvgvIFwGlBeRtVUqPmCI9Q08BPQfn32qPa3phJi7r6CiyNIZsaltove36J9gWe6PS8wLIH3peAt4LyoQ7E0o454I6g/Ot/EEOfPn36tPIvhz7/Hu/8MjQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorManagementSelected);
export default __webpack_public_path__ + "static/media/tutor_management_selected.c6c0015320d7df2eca3da7feb12cf66f.svg";
export { ForwardRef as ReactComponent };